// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"935":"effdfdc3","2190":"85f05151","6703":"87d3b7fc","7850":"6d178cd7","9809":"85f05151"}[chunkId] + ".chunk.css";
};